import {
  Box,
  Button,
  CloseButton,
  HStack,
  Stack,
  Text,
} from "@chakra-ui/react";
import React from "react";
import LabelInput from "./LabelInput";

export default function NotifyCard({ onClose }) {
  return (
    <Stack maxW="80%">
      <HStack align="center">
        <CloseButton onClick={onClose} />
        <Text fontWeight="semibold">Close</Text>
      </HStack>

      <Box>
        <Text
          textDecorationLine="underline"
          fontWeight="semibold"
          fontSize="xl"
        >
          LET US UPDATE YOU
        </Text>
        <Text color="#666666" fontSize="md" fontWeight="light">
          Please enter your email address or phone number to be notified when
          the creation is available and receive similar creation updates.
        </Text>
      </Box>

      <Stack gap={4}>
        <Box>
          <LabelInput label="Email" placeholder="Your email address" />
          <Text fontSize="sm" fontWeight="light">
            However, if you'd prefer to be contacted by phone instead, please
            fill out the fields below
          </Text>
        </Box>
        <LabelInput label="Title" placeholder="Your title" />
        <LabelInput label="First name" placeholder="Your name" />
        <LabelInput label="Last name" placeholder="Your last name" />
        <LabelInput label="Phone number" placeholder="Your phone number" />
      </Stack>

      <Button w="full" variant="unstyled" bg="#022D2D" color="white" my={4}>
        SEND
      </Button>
      <Box fontSize="sm" textAlign="center" fontWeight="light">
        <Text>*Required field</Text>
        <Text>
          This site is protected by reCAPTCHA and the google privacy policy.
          Terms of service apply
        </Text>
      </Box>
    </Stack>
  );
}
